import proxy from "./Proxy";

export default function CardReader() {
    const $Core = window.$Core;
    var self = this;
    function Connect(data) {
        if (!!data && typeof data == "object") {
            window.$Core.App.Emit(
                "ket-noi-dau-doc-the",
                data.MaDauDocThe,
                data.MaLoaiDauDocThe,
                data.TenGiaoThuc,
                data.TenGiaoThuc == "Serial"
                    ? data.COM + ""
                    : data.DiaChiIP + "",
                data.TenGiaoThuc == "Serial"
                    ? parseInt(data.Baud)
                    : parseInt(data.Port)
            );
        }
    }
    function Status(func) {
        $Core.App.On("su-kien-ket-noi", function() {
            console.log("abcd", arguments);
            if (arguments.length > 0) {
                if (arguments[0] == "Succes") {
                    console.log("CardReader -> Kết nối thành công");
                    return func(arguments[1]); //arguments[1] : Id
                } else {
                    console.log("CardReader -> Kết nối không thành công");
                    return func("");
                }
            }
        });
    }
    function DisConnect(id) {
        $Core.App.Off("su-kien-ping-dau-doc-the");

        if (Array.isArray(id)) {
            if (id.length > 0) {
                id.forEach(e => {
                    $Core.App.Emit("ngat-ket-noi-dau-doc-the", e || "");
                });
            } else {
                $Core.App.Emit("ngat-ket-noi-dau-doc-the", id || "");
            }
        }
    }
    function Ping(func) {
        $Core.App.On("su-kien-ping-dau-doc-the", function() {
            console.log("CardReader ping", arguments[0], arguments[1]);
            if (arguments.length > 0) {
                return func(arguments[0], arguments[1]); // arguments[0] : Id , arguments[1] : Ping
            } else {
                return func("");
            }
        });
    }
    function Scan(func) {
        $Core.App.On("su-kien-the", async function() {
            console.log("Scan -> arguments", arguments);
            if (arguments.length > 0) {
                if (arguments[0] == "Succes") {
                    return func(arguments[1]);
                } else {
                    return func("");
                }
            }
        });
    }

    Object.defineProperties(self, {
        Connect: proxy.ForGet(Connect),
        Status: proxy.ForGet(Status),
        DisConnect: proxy.ForGet(DisConnect),
        Ping: proxy.ForGet(Ping),
        Scan: proxy.ForGet(Scan)
    });
}
